import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';

import { SearchFieldComponent } from '../../molecules/search-field/search-field.component';

/**
 * The Help Center finder: a heading, one search box over every answer, and the match count
 * once something is typed. The consumer filters and projects the results beneath it.
 */
@Component({
  selector: 'esn-faq-finder',
  imports: [SearchFieldComponent],
  templateUrl: './faq-finder.component.html',
  styleUrl: './faq-finder.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqFinderComponent {
  readonly heading = input('');
  readonly description = input('');
  readonly placeholder = input('');

  /**
   * The query as typed; two-way via `[(query)]`.
   */
  readonly query = model('');

  /**
   * Consumer-worded match count ("1 answer matches"); shown only while a query is typed.
   */
  readonly countLabel = input('');

  /**
   * Enter in the search box.
   */
  readonly search = output<string>();

  protected readonly showCount = computed(() => !!this.query().trim() && !!this.countLabel());
}
